import { Crown, Star, Sparkles } from "lucide-react";
import { usePlatformSettings } from "../hooks/usePlatformSettings";

const FoundingMemberBadge = ({ memberNumber, size = "large", showDetails = true }) => {
  const { settings } = usePlatformSettings();
  if (size === "small") {
    return (
      <div className="inline-flex items-center bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
        <Crown className="w-4 h-4 mr-1" />
        Founding Member
      </div>
    );
  }

  if (size === "medium") {
    return (
      <div className="inline-flex items-center bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg">
        <Crown className="w-5 h-5 mr-2" />
        <span>Founding Member #{memberNumber}</span>
      </div>
    );
  }

  // Large with details
  return (
    <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 p-1 rounded-xl shadow-2xl">
      <div className="bg-white rounded-lg p-6">
        <div className="text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="relative">
              <Crown className="w-16 h-16 text-yellow-500 animate-bounce" />
              <Sparkles className="w-6 h-6 text-orange-500 absolute -top-2 -right-2 animate-pulse" />
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">
            <h3 className="text-3xl font-extrabold mb-2">
              🌟 FOUNDING MEMBER 🌟
            </h3>
          </div>
          
          <div className="text-gray-900 mb-4">
            <div className="text-5xl font-extrabold mb-2">
              #{memberNumber}
            </div>
            <div className="text-sm text-gray-600">
              You&apos;re one of the first 50!
            </div>
          </div>

          {showDetails && (
            <div className="bg-orange-50 rounded-lg p-4 text-left">
              <div className="font-bold text-orange-900 mb-2">Your Exclusive Benefits:</div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start">
                  <Star className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span><strong>FREE Site Listings For LIFE</strong> - Never pay, even when prices increase</span>
                </li>
                <li className="flex items-start">
                  <Star className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span><strong>Featured Tier FREE</strong> for 90 days ($49/mo value)</span>
                </li>
                {settings.mls_features_enabled && (
                  <li className="flex items-start">
                    <Star className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span><strong>Special MLS Upgrade Pricing</strong> through our broker partners</span>
                  </li>
                )}
                <li className="flex items-start">
                  <Star className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span><strong>Founding Member Badge</strong> - Special status on your listings</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FoundingMemberBadge;
